import React from "react";
import "./App.css";
import Header from "./components/common/Header";
import ManageOrganizationsPage from "./components/organizations/ManageOrganizationsPage";
import SitesController from "./components/sites/SitesController";
import { Navigate, Route, Routes } from "react-router-dom";
import ManageUsersPage from "./components/users/ManageUsersPage";
import ManageUserDetails from "./components/users/ManageUserDetails";
import ProtectedRoute from "./components/common/ProtectedRoute";
import LoginPage from "./components/LoginPage";
import UnauthorizedComponent from "./components/common/UnauthorizedComponent";
import ManageOrganizationDetails from "./components/organizations/ManageOrganizationDetails";
import UnexpectedError from "./components/common/UnexpectedError";
import ManageAiModelZooPage from "./components/aimodelzoo/ManageAiModelZooPage";
import ManageReviewPage from "./components/review/ManageReviewPage";
import ManageExplorePage from "./components/explore/ManageExplorePage";
import ManageProjectsPage from "./components/projects/ManageProjectsPage";
import ManageProjectDetails from "./components/projects/ManageProjectDetails";
import { UploadProvider } from "./components/upload/UploadContext";
import UploadProgressDraggablePopup from "./components/upload/UploadProgressDraggablePopup";
import tailwindClassnames from "./components/common/TailwindClassnames";
import MediaManagement from "./components/mediaManagement/MediaManagement";
import TransferDownloadPage from "./components/transfer/TransferDownloadPage";
import ReportProblemHost from "./components/common/ReportProblemHost";

function App() {
  return (
    <div className={tailwindClassnames.appContainer}>
      {
        <div>
          <Header />
          {/* Sibling of Header, not a child of it: Header renders a logo-only
              skeleton while the profile loads, so a dialog it owned would be
              unreachable exactly when things are slow or broken. It sits outside
              <UploadProvider> because Header does, and it needs no UploadContext. */}
          <ReportProblemHost />
          <UploadProvider>
            <UploadProgressDraggablePopup />
            <Routes>
              {ProtectedRoute({
                path: "/users/:user_id",
                element: (
                  <ManageUserDetails existingUser={true} newAccount={false} />
                ),
              })}
              {ProtectedRoute({
                path: "/myaccount",
                element: (
                  <ManageUserDetails existingUser={true} newAccount={false} />
                ),
              })}
              {ProtectedRoute({
                path: "/users/add",
                element: (
                  <ManageUserDetails existingUser={false} newAccount={false} />
                ),
              })}
              {ProtectedRoute({
                path: "/users/accountCreation/:user_id",
                element: (
                  <ManageUserDetails existingUser={true} newAccount={true} />
                ),
              })}
              {ProtectedRoute({
                path: "/users",
                element: <ManageUsersPage />,
              })}
              {ProtectedRoute({
                path: "/organizations",
                element: <ManageOrganizationsPage />,
              })}
              {ProtectedRoute({
                path: "/addOrganization",
                element: (
                  <ManageOrganizationDetails existingOrganization={false} />
                ),
              })}
              {ProtectedRoute({
                path: "/organizations/:guid/:subpage",
                element: (
                  <ManageOrganizationDetails existingOrganization={true} />
                ),
              })}
              {ProtectedRoute({
                path: "/organizations/:guid/addProject",
                element: <ManageProjectDetails existingProject={false} />,
              })}
              {ProtectedRoute({
                path: "/addProject",
                element: <ManageProjectDetails existingProject={false} />,
              })}
              {ProtectedRoute({
                path: "/",
                element: <ManageProjectsPage />,
              })}
              {ProtectedRoute({
                path: "/projects", // Redirect to root path for /projects
                element: <Navigate to="/" />,
              })}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/unauthorized" element={<UnauthorizedComponent />} />
              <Route path="/unexpectedError" element={<UnexpectedError />} />

              {ProtectedRoute({
                path: "/projects/:projectGuid/:subpage",
                element: <ManageProjectDetails existingProject={true} />,
              })}
              {ProtectedRoute({
                path: "/projects/:projectGuid/:subpage/:deploymentGuid",
                element: <ManageProjectDetails existingProject={true} />,
              })}
              {ProtectedRoute({
                path: "/sites",
                element: <SitesController />,
              })}
              {ProtectedRoute({
                path: "/ai-processing",
                element: <ManageAiModelZooPage />,
              })}
              {ProtectedRoute({
                path: "/ai-processing/:project_guid",
                element: <ManageAiModelZooPage />,
              })}
              {ProtectedRoute({
                path: "/ai-processing/:project_guid/:deployment_guid",
                element: <ManageAiModelZooPage />,
              })}
              {ProtectedRoute({
                path: "/review",
                element: <ManageReviewPage />,
              })}
              {ProtectedRoute({
                path: "/review/:projectGuid",
                element: <ManageReviewPage />,
              })}
              {ProtectedRoute({
                path: "/review/:projectGuid/:deploymentGuid",
                element: <ManageReviewPage />,
              })}
              {ProtectedRoute({
                path: "/review/:projectGuid/:deploymentGuid/image/:imageName",
                element: <ManageReviewPage />,
              })}
              {ProtectedRoute({
                path: "/explore",
                element: <ManageExplorePage />,
              })}
              {ProtectedRoute({
                path: "/transfer",
                element: <TransferDownloadPage />,
              })}
              {ProtectedRoute({
                path: "/manage",
                element: <MediaManagement />,
              })}
              {ProtectedRoute({
                path: "/manage/:project_guid",
                element: <MediaManagement />,
              })}
              {ProtectedRoute({
                path: "/manage/:project_guid/:deployment_guid",
                element: <MediaManagement />,
              })}
            </Routes>
          </UploadProvider>
        </div>
      }
    </div>
  );
}

export default App;
